/**
 * Accessibility enhancement for WordPress core/image lightbox
 *
 * @author MNCA
 */
class A11yLightbox {

     constructor() {
        this.overlay = document.querySelector('.wp-lightbox-overlay');
        if (!this.overlay) return;

        this.wasOpen = false;
        this.initObserver();
    }

    initObserver() {
        this.observer = new MutationObserver(() => {
            this.handleOverlayState();
        });

        this.observer.observe(this.overlay, {
            attributes: true,
            attributeFilter: ['role'],
        });
    }

    handleOverlayState() {
        const isOpen = this.overlay.getAttribute('role') === 'dialog';

        if (isOpen && !this.wasOpen) {
            this.wasOpen = true;
            this.waitForOverlayAnimations(() => {
                this.focusFirstElement();
            });
        }

        if (!isOpen && this.wasOpen) {
            this.wasOpen = false;
        }
    }

    waitForOverlayAnimations(callback) {
    let animationsRunning = 0;

    const onStart = () => {
        animationsRunning++;
    };

    const onEnd = () => {
        animationsRunning--;
        if (animationsRunning === 0) {
            this.overlay.removeEventListener('transitionstart', onStart);
            this.overlay.removeEventListener('transitionend', onEnd);
            this.overlay.removeEventListener('animationstart', onStart);
            this.overlay.removeEventListener('animationend', onEnd);
            callback();
        }
    };

    this.overlay.addEventListener('transitionstart', onStart);
    this.overlay.addEventListener('transitionend', onEnd);
    this.overlay.addEventListener('animationstart', onStart);
    this.overlay.addEventListener('animationend', onEnd);
    }

    focusFirstElement() {
        const firstFocusable = this.overlay.querySelector(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );

        if (firstFocusable) {
            firstFocusable.focus({ preventScroll: true });
        }
    }
}

if (typeof window !== 'undefined') {
    window.A11yLightbox = new A11yLightbox();
}

export default A11yLightbox;
